//
import { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { fromJS } from "immutable"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"
import { selectCustomFields } from "shared/customFields/selectors"
import { loadCustomFields } from "shared/customFields/action-creators"
import { parseAndGenerateCustomFilters } from "shared/search/components/FilterableListView/helperFunctions"

export const createCustomActionFilterGroup = (uniqueFilterGroupId, customDataType) => {
    class UnconnectedCustomFilterGroup extends Component {
        shouldComponentUpdate(nextProps) {
            return (
                !fromJS(nextProps.customTags).equals(fromJS(this.props.customTags)) ||
                nextProps.searchFilterTerm !== this.props.searchFilterTerm
            )
        }

        render() {
            const customActionFilters = parseAndGenerateCustomFilters(this.props.customTags, this.props.customDataType)

            return genericFilterGroup({
                uniqueFilterGroupId,
                filters: customActionFilters,
                displayLabel: "Custom Action Questions",
                helpText: "Filter results by a custom action question.",
                ...this.props,
            })
        }
    }

    UnconnectedCustomFilterGroup.propTypes = {
        additionalFilters: PropTypes.array,
        customDataType: PropTypes.number.isRequired,
        customTags: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        loadCustomFields: PropTypes.func.isRequired,
        searchFilterTerm: PropTypes.string,
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
    }

    const mapStateToProps = (state) => ({
        customTags: selectCustomFields(customDataType)(state).filter((tag) => tag.display_on_profile === true),
    })

    const ConnectedCustomFilterGroup = connect(mapStateToProps, { loadCustomFields })(UnconnectedCustomFilterGroup)

    ConnectedCustomFilterGroup.defaultProps = {
        uniqueFilterGroupId,
        customDataType,
    }

    return ConnectedCustomFilterGroup
}
